import PropTypes from 'prop-types'
import AboutDetails from './AboutDetails'
import Fade from '@mui/material/Fade'
import Modal from '@mui/material/Modal'

const AboutModal = ({ onClose, open }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Fade in={open}>
                <div>
                    <AboutDetails />
                </div>
            </Fade>
        </Modal>
    )
}

AboutModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
}

AboutModal.defaultProps = {
    open: false,
    onClose: () => {},
}

export default AboutModal
